import React from "react";
import { connect } from "react-redux";
import * as Routes from "@js/generated/routes.js";

const SuppressionSearchResults = (props) => {
  if (props.loading || !props.query) {
    return "";
  }

  return (
    <div className="data-table-container subscriber-search-results">
      <div className="result-list-header">
        {I18n.t("notices.email_address_search_results", {
          query: props.query,
          list_type: "suppression lists",
        })}
      </div>
      <table className="data-table data-table-broken-words">
        <thead>
          <tr>
            <th scope="col" style={{ width: "325px" }}>
              {I18n.t("headings.address")}
            </th>
            <th scope="col" style={{ width: "200px" }}>
              {I18n.t("headings.type")}
            </th>
            <th scope="col" style={{ width: "200px" }}>
              {I18n.t("activerecord.models.suppression_list")}
            </th>
            <td />
          </tr>
        </thead>
        <tbody>
          {!props.results || props.results.length === 0 ? (
            <tr>
              <td colSpan={4}>
                {I18n.t("empty_table.subscriber_search_suppression_results")}
              </td>
            </tr>
          ) : (
            props.results.map((result) => {
              let suppressionListPath = Routes.suppression_list_path(
                result.suppression_list_id,
              );
              let suppressionListName = result.suppression_list_name;

              let organizationPath = Routes.organization_path(
                result.organization_id,
              );
              let organizationName = result.organization_name;

              return (
                <tr key={result.id}>
                  <td>{result.email}</td>
                  <td>
                    {t(`suppressed_address_types.${result.address_type}`)}
                  </td>
                  <td>
                    <a href={suppressionListPath}>{suppressionListName}</a>
                    {organizationPath && organizationName && (
                      <div style={{ fontSize: "0.8em", paddingTop: "10px" }}>
                        (<a href={organizationPath}>{organizationName}</a>)
                      </div>
                    )}
                  </td>
                  <td className="actions">
                    <a
                      href={suppressionListPath}
                      className="wordy-action-button view-button action-button button"
                    >
                      <i />{" "}
                      <span>{t("activerecord.models.suppression_list")}</span>
                    </a>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      <br />
      <br />
    </div>
  );
};

const mapStateToProps = (state) => ({
  results: state.suppressionFound,
  loading: state.loading,
  query: state.query,
});

export default connect(mapStateToProps)(SuppressionSearchResults);
